// 处理 public\assets\js\config.js
// 只保留一个示例，配置将在src/store/modules/business.js中进行管理

export const {
  ApiUrl,
  ContentManageApiUrl = '/api',
  SiteCode = '000000000000',
} = window.sysConfig

